var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap justify-center max-w-5xl mx-auto"},_vm._l((_vm.industryBoxes),function(box,index){return _c('SeoBlock',_vm._b({key:("industry-box-" + index),staticClass:"m-2"},'SeoBlock',box,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }